import type { NotificationType } from '#base/core/types/NotificationType';

const state = reactive<{
	notifications: NotificationType[];
}>({
	notifications: [],
});

export const useNotifications = () => {
	const push = (notification: NotificationType, duration = 5000) => {
		state.notifications.unshift(notification);

		setTimeout(() => {
			state.notifications.splice(
				state.notifications.indexOf(notification),
				1
			);
		}, duration);
	};

	return {
		notifications: state.notifications,
		push,
	};
};
